module.exports = __webpack_public_path__ + "assets/img/index-partner14.dadebb58.jpg";